module.exports = __webpack_public_path__ + "img/cdd.3762aaf9.png";